import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from "react-redux";

// Layouts
import Layout from "./layout/Layout";
import PublicLayout from "./layout/public/PublicLayout";

// Public pages
import LendingPage from "./pages/LandingPage/LendingPage";
import LoginPage from "./pages/auth/LoginPage";
import RegistrationPage from "./pages/auth/RegistrationPage";
import ConfirmEmailPage from "./pages/auth/ConfirmEmailPage";
import ResetPasswordPage from "./pages/auth/ResetPasswordPage";
import ForgotPasswordPage from "./pages/auth/ForgotPasswordPage";

// Private pages
import DeckPage from "./pages/DeckPage/DeckPage";
import ContentPage from "./pages/ContentPage/ContentPage";
import ListPage from "./pages/ListPage/ListPage";
import LearnPage from "./pages/LearnPage/LearnPage";
import QuizRunPage from "./pages/PracticeRunPage/QuizRunPage";
import CardRunPage from "./pages/PracticeRunPage/CardRunPage";
import WordRunPage from "./pages/PracticeRunPage/WordRunPage";
import ExamRunPage from "./pages/PracticeRunPage/ExamRunPage";
import ProfilePage from "./pages/ProfilePage/ProfilePage";
import PresetPage from "./pages/PresetPage/PresetPage";
import DebugPage from "./pages/DebugPage/DebugPage";
import AdminAudioPage from "./pages/AdminAudioPage/AdminAudioPage";
import StatPage from "./pages/StatPage/StatPage";
import ProgressPage from "./pages/ProgressPage/ProgressPage";

const AppRoutes = () => {
    const isLoggedIn = useSelector(state => state.auth.isLoggedIn);

    return (
        <Routes>
            {isLoggedIn ? (
                // ----------- Авторизованный Layout -----------
                <Route path="/" element={<Layout />}>
                    {/* Один адрес на страницу: колода жила и на "/", и на "/deck", и
                        подсветка меню на корне не совпадала ни с одним пунктом. */}
                    <Route index element={<Navigate to="/deck" replace />} />
                    <Route path="debug" element={<DebugPage />} />
                    {/* Админка озвучки: пункт меню виден только группе ADMIN, а данные
                        отдаёт бэкенд только роли ADMIN — прямой переход без неё покажет
                        «нет доступа». */}
                    <Route path="admin/audio" element={<AdminAudioPage />} />
                    <Route path="deck" element={<DeckPage />} />
                    <Route path="content" element={<ContentPage />} />
                    <Route path="list" element={<ListPage />} />
                    <Route path="learn" element={<LearnPage />} />
                    <Route path="progress" element={<ProgressPage />} />
                    <Route path="quiz-run" element={<QuizRunPage />} />
                    <Route path="card-run" element={<CardRunPage />} />
                    <Route path="word-run" element={<WordRunPage />} />
                    <Route path="exam-run" element={<ExamRunPage />} />
                    <Route path="profile" element={<ProfilePage />} />
                    <Route path="preset" element={<PresetPage />} />

                    <Route path="stat" element={<StatPage />} />

                    <Route path="*" element={<Navigate to="/" />} />
                </Route>
            ) : (
                // ----------- Публичный Layout -----------
                <Route path="/" element={<PublicLayout />}>
                    {/* Главная страница (index) теперь пусть будет LandingPage */}
                    <Route index element={<LendingPage />} />

                    {/* Или добавьте path="intro" для ЯВНОГО урла /intro */}
                    <Route path="intro" element={<LendingPage />} />

                    <Route path="login" element={<LoginPage />} />
                    <Route path="registration" element={<RegistrationPage />} />
                    <Route path="confirm-email" element={<ConfirmEmailPage />} />
                    <Route path="forgot-password" element={<ForgotPasswordPage />} />
                    <Route path="reset-password" element={<ResetPasswordPage />} />

                    <Route path="*" element={<Navigate to="/" />} />
                </Route>
            )}
        </Routes>
    );
};

export default AppRoutes;
